import classNames from 'classnames';
import React, {FC} from 'react';
import {get_biometry_type} from '~/entities/user';
import faceIdIos from '~/shared/legacy_res/img/touchId/faceid-ios.svg';
import touchIdAndroid from '~/shared/legacy_res/img/touchId/touchid-android.svg';
import touchIdIos from '~/shared/legacy_res/img/touchId/touchid-ios.svg';
import {isAndroid, isIphoneWithFaceId} from '~/shared/utils/mobileDeviceDetect';
import styles from './TouchIdIcon.module.scss';

interface TouchIdIconInterface {
    isPopup?: boolean;
    isLoginBiometryScreen?: boolean;
    inBrowser?: boolean;
    onClick?: () => void;
    title?: string;
}

const TouchIdIcon: FC<TouchIdIconInterface> = ({isPopup, isLoginBiometryScreen, onClick, title, inBrowser}) => {
    const getImgSrc = () => {
        if (isAndroid()) {
            return touchIdAndroid;
        }
        if (inBrowser) {
            return isIphoneWithFaceId() ? faceIdIos : touchIdIos;
        }
        if (get_biometry_type() === 'faceId') {
            return faceIdIos;
        }
        return touchIdIos;
    };

    const getTitle = () => {
        if (title) {
            return `${getText()}${title}`;
        }
        if (get_biometry_type() === 'faceId') {
            return 'Use Face ID';
        }
        return 'Use Touch ID';
    };

    const getText = () => {
        if (isAndroid()) {
            return `Touch ID `;
        }
        if (inBrowser) {
            return isIphoneWithFaceId() ? `Face ID ` : `Touch ID `;
        }
        return `Touch ID `;
    };

    const textClasses = classNames(styles.title, {
        [styles.title_isLoginBiometryScreen]: isLoginBiometryScreen,
        [styles.title_isPopup]: /*          */ !isLoginBiometryScreen && isPopup,
        [styles.title_isBrowserBiometryScreen]: inBrowser,
    });

    const containerClasses = classNames(styles.container, {
        [styles.container_isPopup]: isPopup,
    });

    const imgClasses = classNames({
        [styles.containerImg]: isLoginBiometryScreen || isPopup,
        [styles.containerImg_isLoginBiometryScreen]: isLoginBiometryScreen,
    });

    return (
        <div className={containerClasses} onClick={onClick}>
            <div className={imgClasses}>
                <img src={getImgSrc()} />
            </div>
            <p className={textClasses}>{getTitle()}</p>
        </div>
    );
};

export default TouchIdIcon;
